import { stringify as stringifyQs } from "qs";
import urlJoin from "url-join";

import {
  ActiveTab,
  BulkAction,
  Dialog,
  Filters,
  Pagination,
  SingleAction,
  Sort,
  TabActionDialog
} from "../types";

export const pageheaderSection = "/pageheaders/";
export const pageheaderRefresh = "/pageheaders/#";

export const pageheaderListPath = pageheaderSection;

export enum PageheaderListUrlSortField {
  id = "id",
  name = "name",
  created = "created"
}

export enum PageheaderListUrlFiltersEnum {
  isDefault = "isDefault",
  query = "query"
}
export type PageheaderListUrlDialog = "remove" | "export" | TabActionDialog;
export type PageheaderListUrlFilters = Filters<PageheaderListUrlFiltersEnum>;
export type PageheaderListUrlSort = Sort<PageheaderListUrlSortField>;
export type PageheaderListUrlQueryParams = ActiveTab &
  PageheaderListUrlFilters &
  PageheaderListUrlSort &
  BulkAction &
  Dialog<PageheaderListUrlDialog> &
  Pagination;

export const pageheaderListUrl = (params?: PageheaderListUrlQueryParams) =>
  pageheaderListPath + "?" + stringifyQs(params);
export type PageheaderAddUrlDialog =
  | "add-value"
  | "edit-value"
  | "remove-value"
  | "remove-values";
export type PageheaderUrlDialog =
  | "add-value"
  | "edit-value"
  | "remove"
  | "remove-value"
  | "remove-values"
  | "apply-pageheader";
export type PageheaderAddUrlQueryParams = Dialog<PageheaderAddUrlDialog> &
  SingleAction;
export type PageheaderUrlQueryParams = Pagination & BulkAction &
  Dialog<PageheaderUrlDialog> ;
export const pageheaderAddPath = urlJoin(pageheaderSection, "add");

export const pageheaderAddUrl = (params?: PageheaderAddUrlQueryParams) =>
  pageheaderAddPath + "?" + stringifyQs(params);

export const pageheaderPath = (id: string) => urlJoin(pageheaderSection, id);
export const pageheaderUrl = (id: string, params?: PageheaderUrlQueryParams) =>
pageheaderPath(encodeURIComponent(id)) + "?" + stringifyQs(params);
